module.exports = __webpack_public_path__ + "media/Yarn2.460ad3c9.mp4";